export interface I18nConfig {
  fallbackLng: string;
  supportedLngs: string[];
  defaultNS: string;
  ns: string[];
  debug: boolean;
  keySeparator: string;
  interpolation: {
    escapeValue: boolean;
  };
}

export const i18nConfig: I18nConfig = {
  fallbackLng: 'ua',
  supportedLngs: ['ua', 'en'],
  defaultNS: 'common',
  ns: ['common', 'validation', 'errors', 'auth'],
  debug: false,
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
};

export default i18nConfig;
